"use client";

import { createContext, useContext, ReactNode } from "react";
import { useSettings } from "@/hooks/use-settings";

type TimeFormat = "12h" | "24h";

const TimeFormatContext = createContext<TimeFormat>("12h");

export function TimeFormatProvider({ children }: { children: ReactNode }) {
  const { settings } = useSettings();
  const timeFormat = settings?.timeFormat ?? "12h";

  return (
    <TimeFormatContext.Provider value={timeFormat}>
      {children}
    </TimeFormatContext.Provider>
  );
}

export function useTimeFormat() {
  return useContext(TimeFormatContext);
}
